import {checkAuthenticated} from '../../actions/AuthenticationActionCreators';

async function requireLogin(nextState) {
  console.info('Checking for authentication');
  const context = nextState.routes[0].getContext();
  await context.executeAction(checkAuthenticated, {routes: nextState.routes});
  const PortalUserStore = context.getStore('PortalUserStore');
  const authenticated = PortalUserStore.userLoggedIn();

  const {location: {pathname, search} = {}} = nextState;
  const toReturn = {};
  if (!authenticated) {
    const returnPath = pathname + search;
    const newLocation = {
      pathname: '/account/login',
      search: `?redirect=${returnPath}`
    };
    console.info('User not authenticated.  Redirecting to login page', returnPath, newLocation, nextState);
    toReturn.redirect = newLocation;
  }

  return toReturn;
}

export default requireLogin;



// WEBPACK FOOTER //
// ./src/utils/route/requireLogin.js